import Swal from 'sweetalert2'
export function ClearStorage() {
  const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  localStorage.removeItem('auth_storage')
  localStorage.removeItem('permissions_storage')
  localStorage.removeItem('user_storage')
  localStorage.removeItem('roles_storage')
  localStorage.removeItem('kt-auth-react-v')
  localStorage.removeItem('cookie')

  Swal.fire({
    icon: 'error',
    title: 'Desculpe, sua sessão expirou.',
    text: 'Por favor, faça login novamente para continuar usando nossa aplicação',
    showConfirmButton: false,
    timer: 3000,
  })
  setTimeout(() => {
    window.location.href = '/auth/login'
  }, 3500)
}
